/*
 * Accessibility clean-up for slick carousels (vendor.min.js).
 * The bundled slick version adds ARIA roles (listbox/option/tablist/presentation)
 * that are invalid in this markup and leaves arrows without an accessible name.
 * This runs after every slick init/change and normalises the attributes.
 * Remove this file (and its include in layout/theme.liquid) to revert.
 */
(function ($) {
  if (!$ || !$.fn) return;

  var labels = $.extend(
    { prev: 'Previous slide', next: 'Next slide', slide: 'Slide' },
    window.slickA11yLabels || {}
  );

  function fix($slider) {
    $slider.find('.slick-track').removeAttr('role');
    $slider.find('.slick-slide').removeAttr('role aria-describedby');

    var $dots = $slider.find('.slick-dots');
    $dots.removeAttr('role');
    $dots.find('li').removeAttr('role aria-selected aria-controls aria-hidden');
    $dots.find('li button').removeAttr('role aria-controls').each(function (i) {
      if (!this.getAttribute('aria-label')) {
        this.setAttribute('aria-label', labels.slide + ' ' + (i + 1));
      }
    });

    $slider.find('.slick-prev').attr('aria-label', labels.prev);
    $slider.find('.slick-next').attr('aria-label', labels.next);

    // Focusable elements inside hidden slides must not be reachable by keyboard.
    $slider.find('.slick-slide').each(function () {
      var hidden = this.getAttribute('aria-hidden') === 'true';
      $(this).find('a, button, input, select, textarea, [tabindex]').each(function () {
        if (hidden) {
          if (this.getAttribute('tabindex') !== '-1') {
            this.setAttribute('data-a11y-tabindex', this.getAttribute('tabindex') || '');
            this.setAttribute('tabindex', '-1');
          }
        } else if (this.hasAttribute('data-a11y-tabindex')) {
          var prev = this.getAttribute('data-a11y-tabindex');
          if (prev === '') this.removeAttribute('tabindex'); else this.setAttribute('tabindex', prev);
          this.removeAttribute('data-a11y-tabindex');
        }
      });
    });
  }

  // This slick build triggers 'init'/'reInit' *before* it applies its ARIA
  // attributes (initADA), and 'refresh' re-initialises without any init event
  // but always ends with 'setPosition'. Clean-up is deferred to the next tick.
  // e.target is used because the 'slick-slider' class may not be set yet.
  var pending = [];
  $(document).on('init reInit breakpoint setPosition afterChange', function (e) {
    var el = e.target;
    if (!el || !el.className || String(el.className).indexOf('slick') === -1) return;
    if (pending.indexOf(el) !== -1) return;
    pending.push(el);
    setTimeout(function () {
      pending.splice(pending.indexOf(el), 1);
      fix($(el));
    }, 0);
  });

  $(function () {
    $('.slick-initialized').each(function () { fix($(this)); });
  });
})(window.jQuery);
